import { combineReducers } from "redux-immutable";

import Classroom from "../models/Classroom";

import meta from "./meta";
import learningMode from "./learningMode";
import sessionUI from "./sessionUI";
import sidebarUI from "./sidebarUI";

export default combineReducers(
  {
    meta,
    learningMode,
    sessionUI,
    sidebarUI
  },
  () => new Classroom() as any
);
